import { render, staticRenderFns } from "./NewCollisionCheck.vue?vue&type=template&id=53889bab&scoped=true"
import script from "./NewCollisionCheck.vue?vue&type=script&lang=js"
export * from "./NewCollisionCheck.vue?vue&type=script&lang=js"
import style0 from "./NewCollisionCheck.vue?vue&type=style&index=0&id=53889bab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53889bab",
  null
  
)

export default component.exports